export const SEV_2_PROJECT_BOARD_URL = 'sev2/project-board-url'
export const SEV_2_PROJECT_TAG_NAME = 'sev2/project-tag-name'

export const BACKSTAGE_SOURCE_LOCATION = 'backstage.io/source-location'
export const QUERY_KEY_AVAILABLE_TICKET = 'eajlQpko7DhV'

export const BACKLOG = 'Backlog';
export const IN_REVIEW = 'Ticket In Review';
export const GROOMED = 'Groomed';
export const TO_DO = 'To Do';
export const BLOCKED = 'Blocked';
export const REJECTED = 'Rejected';
export const IN_PROGRESS = 'In Progress';
export const CODE_REVIEW = 'Code Review';
export const READY_TO_TEST = 'Ready To Test';
export const INTERNAL_TESTING = 'Internal Testing';
export const READY_FOR_PROD = 'Ready for Prod';
export const DEPLOYED_TO_PROD = 'Deployed to Prod';
export const WAITING_VERIFICATION = 'Waiting Verification';
export const DONE = 'Done';

// AI
export const AI_DAILY_REPORT = 'daily_report';
export const AI_SPELLCHECK = 'spellcheck';

export const BASE_BOARD_POSITION = [
  BACKLOG,
  IN_REVIEW,
  GROOMED,
  TO_DO,
  BLOCKED,
  REJECTED,
  IN_PROGRESS,
  CODE_REVIEW,
  READY_TO_TEST,
  INTERNAL_TESTING,
  READY_FOR_PROD,
  DEPLOYED_TO_PROD,
  WAITING_VERIFICATION,
  DONE
];

export const SEV2_BACKSTAGE_ERROR_TRACKING_PROJECT_ID = 3207;
export const SEV2_BACKSTAGE_EXTERNAL_SELF_RESOLVE_PROJECT_ID = 3208;
export const SEV2_BACKSTAGE_REFACTORY_SELF_RESOLVE_PROJECT_ID = 3235;
export const EXTERNAL_USER_ACTION_SEND_TO_REFACTORY_REASON = 'Sending Task to Refactory'
export const EXTERNAL_USER_ACTION_SEND_TO_REFACTORY_COST = -1
